import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import React from 'react';
import ReactDOM from 'react-dom';

import { utils as commonUtils } from '@finley-technologies/common';

import { Entry } from 'core/Entry';

Sentry.init({
  environment: commonUtils.EnvUtils.getEnv(),
  dsn:
    'https://6a28f45305234366a8ed79c601b3f9c7@o686378.ingest.sentry.io/5784832',
  release: PACKAGE_VERSION,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // Sentry recommends adjusting this value in production
  tracesSampleRate: commonUtils.EnvUtils.isProduction() ? 0.9 : 1.0,
  integrations: [new Integrations.BrowserTracing()],
  beforeBreadcrumb(breadcrumb) {
    const updatedBreadcrumb = { ...breadcrumb };
    // null out the XHR log for s3 requests
    if (
      updatedBreadcrumb.category === 'xhr' &&
      updatedBreadcrumb.data &&
      updatedBreadcrumb.data.url.includes('amazonaws.com')
    ) {
      updatedBreadcrumb.data.url = '[FILTERED AWS REQUEST]';
    }
    return breadcrumb;
  },
});

const render = (ApplicationEntry: React.FunctionComponent) => {
  ReactDOM.render(<ApplicationEntry />, document.getElementById('root'));
};
render(Entry);

// This is needed for Hot Module Replacement in webpack
// Since we have now moved to Vite, this is no longer needed,
// I'm commenting it out for now, But keeping it around
// in case we ever wanted to debug locally with webpack builds.
// if (module.hot) {
//   // Hot-reload everything down-tree of the store providers, but force full
//   // reload if and middleware or reducers are altered.
//   module.hot.accept('./core/Entry', () => {
//     const { Entry: NextEntry } = require('./core/Entry'); // eslint-disable-line
//     render(NextEntry);
//   });
// }
